<div class="select-trigger-content flex-space-between flex-align-center c-p pad-0-S border-box-full" [class.multi-select-readonly]="readonly" [style.cursor]="readonly ? 'default' : 'pointer'" [class.bkg-light-grey]="!readonly || (readonly && appearance === 'chips')" [class.bkg-white]="readonly && appearance !== 'chips' && appearance !== 'chips-v2'"
  [style.min-height.px]="minHeight ? minHeight : undefined"
  [style.border]="border ? border : undefined"
  [class]="'appearance-' + appearance" [class.error]="error" [class.warning]="warning">
  <div class="flex-align-center gap-XS select-trigger-text font-M fw-500 text-overflow-ellipsis"
    [class.warning]="warning" [class.select-trigger-text-v2]="appearance === 'chips-v2'">
    @if (icon && appearance === 'chips-v2') {
      <img class="select-trigger-prefix-icon" [src]="icon" alt="">
    }
    @if (warning) {
      <img width="12" src="assets/icons/warning-triangle.svg">
    }
    <ng-content></ng-content>
  </div>
  @if (!readonly && appearance !== 'chips-v2') {
    <img class="select-trigger-icon" [ngClass]="{'filter-grey': appearance === 'chips' && !warning,  'filter-warning': appearance === 'chips' && warning}"
      style="transform: rotate(90deg)"
      ngSrc="assets/icons/arrow-right-black.svg" height="11" width="11" alt="">
    }
    @if (!readonly && appearance === 'chips-v2') {
      <img class="select-trigger-icon-v2"
        style="transform: rotate(90deg)"
        ngSrc="assets/icons/arrow-right-black.svg" height="9" width="5" alt="">
      }
    </div>
